<div class="lower-content">
  <div *ngIf="isLoading" class="loader">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

  <table mat-table [dataSource]="tableData" multiTemplateDataRows class="table" *ngIf="!isLoading">
    <ng-container matColumnDef="action">
      <th mat-header-cell class="header" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <i *ngIf="element.enableExpansion && (!expandedElement || expandedElement.id !== element.id)" class="uil uil-angle-down"></i>
        <i *ngIf="element.enableExpansion && expandedElement?.id === element.id" class="uil uil-angle-up"></i>
      </td>
    </ng-container>

    <ng-container *ngFor="let column of columnsDefinition" [matColumnDef]="column.key">
      <th mat-header-cell class="header" *matHeaderCellDef>{{column.text}}</th>
      <td mat-cell *matCellDef="let element">{{element[column.key]}}</td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <ng-container *ngIf="element.type === EventType.FINISH">
          <div class="expanded-detail"
            [@detailExpand]="element.enableExpansion && element == expandedElement ? 'expanded' : 'collapsed'">
            <div class="left">
            <h4>Conferidos</h4>
            <app-material-generic-table
              [dataSource]="element.checkedPallets"
              [columnsDefinition]="palletDetailColumnDefinition"
              [displayedColumns]="palletDetailDisplayedColumns">
            </app-material-generic-table>
          </div>
          <mat-divider vertical></mat-divider>
          <div class="right">
            <h4>Faltantes</h4>
            <app-material-generic-table
              [dataSource]="element.missingPallets"
              [columnsDefinition]="palletDetailColumnDefinition"
              [displayedColumns]="palletDetailDisplayedColumns">
            </app-material-generic-table>
          </div>
        </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row class="header-container" *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row class="row" *matRowDef="let element; columns: displayedColumns; let i = dataIndex"
      [class.light-gray]="i % 2"
      [class.cursor-pointer]="element.enableExpansion" 
      [class.expanded-row]="expandedElement === element"
      (click)="element.enableExpansion && expandedElement = expandedElement === element ? null : element">
    </tr>

    <tr mat-row *matRowDef="let element; columns: ['expandedDetail']; let i = dataIndex"
      class="detail-row" [class.light-gray]="i % 2">
    </tr>
  </table>

  <div *ngIf="!tableData.length && !isLoading" class="no-item">
    Não existe histórico para esta ordem
  </div>
</div>
